import _get from 'lodash/get';
import base from './Base';

const themeColor = {
  primary: '#7ebf4c',
  secondary: '#442b6a',

  // used for inner elements-specific to theme
  theme: '#442b6a',
};

const logo = {
  width: 180,
  height: 80,
  left: 32,
  top: 36,
  mobileWidth: 100,
  pageTileMarginTop: 10,
  default: `url(${_get(window.ORGBranding, 'defaultBrand.fleetSmart.logo.white')})`,
  colour: `url(${_get(window.ORGBranding, 'defaultBrand.fleetSmart.logo.colour')})`,
  white: `url(${_get(window.ORGBranding, 'defaultBrand.fleetSmart.logo.white')})`,
};

const dashboard = {
  driver: '#0b223d',
  vehicle: '#0b223d',
};

const theme = {
  ...base,
  color: { ...base.color, ...themeColor },
  dashboard,
  logo,
};

export default theme;



// WEBPACK FOOTER //
// ./src/themes/themes/FleetSmart.js